import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <React.Fragment>
    <path fillOpacity=".3" d="M2 22h20V2z" />
    <path d="M17 7L2 22h15z" />
  </React.Fragment>,
  'SignalCellular3Bar',
);
